import {BaseEndpoint} from "@/api/BaseEndpoint";

class Fairs extends BaseEndpoint{}

export default (new BaseEndpoint('fairs'));